import { createSlice } from '@reduxjs/toolkit';
const slice = createSlice({
    name: 'ui_stories_ids',
    initialState: () => {
        return window.PRELOAD?.ui_stories_ids ?? { new_ids: [], viewed_ids: [] };
    },
    reducers: {
        change_of_status_stories_state: (state, action) => {
            action.payload.forEach((view_id) => (state = {
                new_ids: state.new_ids.filter((id) => id !== view_id),
                viewed_ids: [...state.viewed_ids, view_id],
            }));
        },
    },
});
export const { change_of_status_stories_state } = slice.actions;
export const storiesUi = slice.reducer;
export const change_stories_status = (id_storys) => async (dispatch, getState, { api }) => {
    try {
        const response = await api.change_ui_stories(id_storys);
        if (response.ok) {
            dispatch(change_of_status_stories_state(id_storys));
        }
    }
    catch (error) {
        console.log(error);
    }
};
